import { COLOR } from '../../theme/constant';
import { HomeOutlined, UserOutlined, HeartOutlined, InfoCircleOutlined,SignatureOutlined, KeyOutlined,VideoCameraOutlined, BellOutlined, AlertOutlined, ClockCircleOutlined, CalendarOutlined, SafetyOutlined, SettingOutlined, SmileOutlined, MobileOutlined } from '@ant-design/icons';



const data = [
  { section:'A', color: COLOR.belizeHole , name: 'Company Settings', icon: <SettingOutlined />, path: 'inactive' },
  { section:'A', color: COLOR.alizarin , name: 'Meeting Integration Settings', icon: <VideoCameraOutlined/>, path: 'inactive' },
  // { section:'A', color: COLOR.greenSea , name: 'Organization Color', icon: <KeyOutlined />, path: 'inactive' },
  { section:'B', color: COLOR.emerald , name: 'Profile Settings', icon: <UserOutlined />, path: 'inactive' },
  { section:'B', color: COLOR.sunflower , name: 'Password Change', icon: <SafetyOutlined />, path: 'inactive' },
  { section:'B', color: COLOR.midnightBlue , name: 'eSignature', icon: <SignatureOutlined />, path: 'inactive' },
  { section:'B', color: COLOR.pomegranate500 , name: '2FA', icon: <MobileOutlined />, path: 'inactive' },
];

export default data;